export default "__VITE_ASSET__DxvEEoch__"